/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// style imports
import './CheckExists.scss';

// library imports
import { Component } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import store from 'features/store';
import { ACCESS_TOKEN, REFRESH_TOKEN } from 'shared/settings/token';
import authService from 'shared/services/authService';
import { login } from 'shared/settings/auth';

/**

@Author Karthik

@param

@return html code for check exists Page

**/

export class CheckExists extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            errorMessage: ""
        }
    }

    updateDimensions = () => {
        this.setState({
            ...this.state,
            innerWidth: window.innerWidth
        });
    }

    handleClose = (event) => {
        store.dispatch({ type: "TOGGLE_CHECK_EXISTS_MODAL", payload: { show: false, extraData: null } });
    }

    socialMediaSignInAndSignUp = () => {
        this.setState({
            loader: true,
            errorMessage: ""
        }, () => {
            const data = this.props.checkExistsModal.extraData.data;
            const media = this.props.checkExistsModal.extraData.media;
            switch (media) {
                case "google":
                    authService.googleAuth(data).then(
                        response => {
                            const jsonData = response.data;
                            login({ [ACCESS_TOKEN]: jsonData['accessToken'], [REFRESH_TOKEN]: jsonData['refreshToken'] });
                        }
                    ).catch(error => {
                        this.setState({
                            errorMessage: error.message,
                            loader: false
                        });
                    });
                    break;
                case "facebook":
                    authService.facebookAuth(data).then(
                        response => {
                            const jsonData = response.data;
                            login({ [ACCESS_TOKEN]: jsonData['accessToken'], [REFRESH_TOKEN]: jsonData['refreshToken'] });
                        }
                    ).catch(error => {
                        this.setState({
                            errorMessage: error.message,
                            loader: false
                        });
                    });
                    break;
                case "apple":
                    authService.appleAuth(data).then(
                        response => {
                            const jsonData = response.data;
                            login({ [ACCESS_TOKEN]: jsonData['accessToken'], [REFRESH_TOKEN]: jsonData['refreshToken'] });
                        }
                    ).catch(error => {
                        this.setState({
                            errorMessage: error.message,
                            loader: false
                        });
                    });
                    break;
                default:
                    console.error("Out of range");
                    break;
            }
        });
    }

    componentWillUnmount() {
        this.setState({
            loader: false
        });
    }

    render() {
        return (
            <Modal id="check-exists-modal-main"
                show={this.props.checkExistsModal.show} onHide={this.handleClose} animation={false}
                className=" animate__animated animate__fadeInUp"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <div className="content-container">
                        <div className="text-center my-2">
                            {
                                this.props.checkExistsModal.extraData.error ? this.props.checkExistsModal.extraData.errorMessage : "This email already exists. Do you want link with that account."
                            }
                        </div>
                        {
                            this.state.errorMessage ?
                                <div className="api-error my-2">{this.state.errorMessage}</div> : null
                        }
                        <div className="d-flex align-items-center justify-content-center">
                            <Button variant="outline-dark btn-white mx-2" onClick={this.handleClose}>
                                {
                                    this.props.checkExistsModal.extraData.error ? "Close" : "No"
                                }
                            </Button>
                            {
                                this.props.checkExistsModal.extraData.error ? null :
                                    <Button variant="secondary mx-2" onClick={this.socialMediaSignInAndSignUp} disabled={this.state.loader}>
                                        Yes {' '} {this.state.loader ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"></Spinner> : null}
                                    </Button>
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}